// src/components/intake/IntakeWelcome.js
//
// Ticket 061. The first screen. Says plainly that nothing is saved until the
// email is confirmed after Section 1. One component for signed-in and signed-out
// (rule 12): the same two buttons either way.

import React from 'react'

export default function IntakeWelcome({ partnerName, onStart, onContinue }) {
  return (
    <div>
      <h1 className="triage-question">Tell us about your tax situation</h1>
      {partnerName && <p className="intake-notice">Referred by {partnerName}</p>}
      <p className="triage-hint">
        A short set of questions so your advisor can prepare. Section 1 takes about three minutes.
        Nothing is saved until you confirm your email at the end of Section 1. After that, your answers
        are saved and you can come back from any device.
      </p>
      <div className="intake-actions">
        <button type="button" className="triage-next" onClick={onStart}>Start</button>
        <button type="button" className="btn-secondary" onClick={onContinue}>Continue where I left off</button>
      </div>
    </div>
  )
}
